import { Play, Clapperboard } from "lucide-react";
import { PROJECT_VIDEOS } from "../data/content";
import { Reveal, Overline } from "./Reveal";

export const Videos = () => (
  <section id="videos" data-testid="videos-section" className="blueprint-grid-dark bg-navy-deep py-20 sm:py-28">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal>
        <Overline light>Project films</Overline>
        <h2 className="mt-4 max-w-3xl font-display text-3xl font-extrabold tracking-tight text-white sm:text-5xl">
          Watch our work come alive.
        </h2>
        <p className="mt-5 max-w-2xl text-base leading-relaxed text-blue-200/80">
          Site walkthroughs, 3D flythroughs and before-after films from our projects.
        </p>
      </Reveal>

      <Reveal delay={0.15}>
        <div className="mt-14 flex items-center gap-3 border-b border-white/15 pb-4">
          <Clapperboard size={18} className="text-electric" />
          <p className="font-mono text-xs font-bold uppercase tracking-[0.25em] text-blue-200">
            Project Video Library — {PROJECT_VIDEOS.length} films
          </p>
        </div>
        <div className="mt-8 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-5" data-testid="project-videos-grid">
          {PROJECT_VIDEOS.map((v) => (
            <div
              key={v.id}
              data-testid={`project-video-${v.id}`}
              className="group relative aspect-video overflow-hidden border border-white/15 bg-navy transition-colors hover:border-electric"
            >
              {v.src ? (
                <>
                  <video controls playsInline preload="metadata" className="h-full w-full object-cover">
                    <source src={`${v.src}.webm`} type="video/webm" />
                    <source src={`${v.src}.mp4`} type="video/mp4" />
                  </video>
                  <span className="pointer-events-none absolute bottom-0 left-0 right-0 bg-navy/85 px-2 py-1 font-mono text-[9px] font-bold uppercase tracking-[0.1em] text-white">
                    {v.title}
                  </span>
                </>
              ) : (
                <div className="flex h-full w-full flex-col items-center justify-center gap-2">
                  <span className="flex h-9 w-9 items-center justify-center border border-white/25 text-blue-200 transition-colors group-hover:border-electric group-hover:text-electric">
                    <Play size={15} />
                  </span>
                  <span className="font-mono text-[10px] font-bold tracking-[0.2em] text-blue-300/60">
                    FILM {v.index}
                  </span>
                  <span className="font-mono text-[9px] uppercase tracking-[0.12em] text-blue-300/40">
                    Uploading soon
                  </span>
                </div>
              )}
            </div>
          ))}
        </div>
      </Reveal>
    </div>
  </section>
);
